export function useIsTouchDevice() {
	return navigator.maxTouchPoints > 0;
}
